import { Drawer, Layout } from "antd";
import { ReactNode, Suspense } from "react";
import SidebarContent from "../components/common/sidebar/SidebarContent";
import SidebarItems from "../components/common/sidebar/SidebarItems";
import Loader from "../components/ui/Loader";
import useSidebar from "../hooks/useSidebar";
import AppLayout from "./AppLayout";

export interface SidebarLayoutProps {
  children?: ReactNode;
  title?: string;
  backLink?: string;
  tabList?: {
    label: string;
    link: string;
  }[];
  isHide?: boolean;
  isLogoTitle?: boolean;
  className?: string;
  hideHeaderActions?: boolean;
}

export default function SidebarLayout({
  children,
  title,
  backLink,
  tabList,
  isHide,
  isLogoTitle,
  className,
  hideHeaderActions,
}: SidebarLayoutProps) {
  const {
    collapsed,
    openSidebar,
    openMenuKeys,
    handleOpenMenu,
    handleCollapsed,
    handleShowSidebar,
    handleCloseSidebar,
  } = useSidebar();

  // const { user } = useAppSelector((state) => state.auth);

  return (
    <div>
      {/* {!user?.data?.email_verified ? (
        <div className="h-12 bg-[#f6ddbc] flex justify-center items-center text-center text-sm font-medium !text-[#fa6400] sticky z-[999] w-full top-0">
          <AlertIcon />
          <span className="px-2">Your email address isn’t verified yet.</span>
          <Link to="/verify-account">
            <Button type="primary" className="!h-7 !text-xs" size="small">
              Verify Now
            </Button>
          </Link>
        </div>
      ) : null} */}
      <Layout>
        {!isHide && (
          <>
            <div className="lg:hidden ">
              <Drawer
                placement="left"
                closable={false}
                onClose={handleCloseSidebar}
                open={openSidebar}
                key="left"
                contentWrapperStyle={{ width: "auto" }}
                bodyStyle={{ padding: 0, overflowY: "hidden" }}
              >
                <SidebarItems
                  collapsed={false}
                  openMenuKeys={openMenuKeys}
                  handleOpenMenu={handleOpenMenu}
                  isMobile
                />
              </Drawer>
            </div>
            <div className="hidden lg:block border-r border-extra-light">
              <SidebarItems
                collapsed={collapsed}
                openMenuKeys={openMenuKeys}
                handleOpenMenu={handleOpenMenu}
              />
            </div>
          </>
        )}

        {/* Sidebar content is main children component, where show children data. This component contains Header items like: Profile and Notification  */}
        <AppLayout
          title={title}
          className={`w-full ${
            !isHide
              ? collapsed
                ? "lg:w-[calc(100vw-80px)]"
                : "lg:w-[calc(100vw-312px)]"
              : ""
          }`}
        >
          <SidebarContent
            collapsed={collapsed}
            handleCollapsed={handleCollapsed}
            handleShowSidebar={handleShowSidebar}
            title={title}
            backLink={backLink}
            tabList={tabList}
            isLogoTitle={isLogoTitle}
            className={className}
            isHide={isHide}
            hideHeaderActions={hideHeaderActions}
          >
            <Suspense fallback={<Loader />}>{children}</Suspense>
          </SidebarContent>
        </AppLayout>
      </Layout>
    </div>
  );
}
